// Module
var code = "<nav3-menu> <nav3-menu-col> <nav3-menu-item id=\"google-nav-dropdown-item\" state=\"tagging\" text=\"Google Product Collection\"></nav3-menu-item> </nav3-menu-col> </nav3-menu> ";
// Exports
module.exports = code;